import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_EnNavbar = _resolveComponent("EnNavbar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_EnFooter = _resolveComponent("EnFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.lang=='fa' && _ctx.path!='/sign-in' && _ctx.path!='/sign-up'&&_ctx.path!='/test'&&_ctx.path!='/dashboard'&&_ctx.path!='/sign-in-signals'&&_ctx.path!='/online-signals')
      ? (_openBlock(), _createBlock(_component_Navbar, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.lang=='en' && _ctx.path!='/sign-in' && _ctx.path!='/sign-up'&&_ctx.path!='/test'&&_ctx.path!='/dashboard'&&_ctx.path!='/sign-in-signals'&&_ctx.path!='/online-signals')
      ? (_openBlock(), _createBlock(_component_EnNavbar, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    (_ctx.lang=='fa' && _ctx.path!='/online-signals' && _ctx.path!='/sign-in' && _ctx.path!='/sign-up'&& _ctx.path!='/test'&&_ctx.path!='/dashboard'&&_ctx.path!='/online-signals'&&_ctx.path!='/sign-in-signals')
      ? (_openBlock(), _createBlock(_component_Footer, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.lang=='en' && _ctx.path!='/online-signals' && _ctx.path!='/sign-in' && _ctx.path!='/sign-up'&& _ctx.path!='/test'&&_ctx.path!='/dashboard'&&_ctx.path!='/online-signals'&&_ctx.path!='/sign-in-signals')
      ? (_openBlock(), _createBlock(_component_EnFooter, { key: 3 }))
      : _createCommentVNode("", true)
  ], 64))
}